import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { Money } from '@app/features/scope-overview/model/money.model'
import { ScopeSection } from '@app/features/scope-overview/model/scope-section'

export class DeliverableMoneyUtils {
  static prepareDeliverable(deliverable: Deliverable): any {
    const currency = deliverable.currencyUnit || 'GBP'
    const prepareDeliverable = { ...deliverable }

    this.ensureMoneyFieldsHaveCurrency(prepareDeliverable, currency)
    this.ensureSourceFieldExists(prepareDeliverable, deliverable)
    this.updateCalculatedValues(prepareDeliverable, deliverable)

    return prepareDeliverable
  }

  static addAndNormalizeMoney(total: Money, amountToAdd: Money): Money {
    if (amountToAdd.currency !== total.currency) {
      const normalizedAmount = new Money(amountToAdd.amount, total.currency)
      return total.add(normalizedAmount)
    }
    return total.add(amountToAdd)
  }

  private static ensureMoneyFieldsHaveCurrency(deliverable: any, currency: string): void {
    const fields = ['budget', 'budgetBalance', 'fixedCostOffset']

    fields.forEach((field) => {
      if (typeof deliverable[field] === 'number') {
        deliverable[field] = new Money(deliverable[field], currency)
      } else if (deliverable[field] && !deliverable[field]?.currency) {
        deliverable[field].currency = currency
      }
    })
  }

  private static ensureSourceFieldExists(processed: any, original: Deliverable): void {
    if (!processed.source) {
      processed.source = original.source || {}
    }
  }

  private static updateCalculatedValues(processed: any, original: Deliverable): void {
    const calculatedValues = { ...(processed.calculatedValues || {}) }

    const fieldsToUpdate = [
      {
        fieldName: 'rateCardTotalMinutes',
        currentValue: original.getTotalRateCardHours(),
        transform: (hours) => hours * 60,
      },
      {
        fieldName: 'totalSellingPrice',
        currentValue: original.getTotalSellingPrice(),
        transform: (money) => money.amount,
      },
      { fieldName: 'totalProfit', currentValue: original.getTotalProfit(), transform: (money) => money.amount },
      { fieldName: 'totalCostPrice', currentValue: original.getTotalCostPrice(), transform: (money) => money.amount },
    ]

    fieldsToUpdate.forEach(({ fieldName, currentValue, transform }) => {
      if (currentValue != null && calculatedValues[fieldName]) {
        calculatedValues[fieldName] = transform(currentValue)
      }
    })

    processed.calculatedValues = calculatedValues
  }

  static prepareSection(sectionData: any): ScopeSection {
    const prepareSection = Object.assign(new ScopeSection(), sectionData)
    const currency = prepareSection.currencyUnit || 'GBP'

    const moneyFields = [
      'totalSellingPrice',
      'totalProfit',
      'unitSellingPrice',
      'unitProfit',
      'naturalSellingPrice',
      'totalCostPrice',
      'unitCostPrice',
    ]

    moneyFields.forEach((field) => {
      if (sectionData[field] != null) {
        prepareSection[field] = new Money(sectionData[field], currency)
      }
    })

    return prepareSection
  }
}
